<div
  style="background-image: url(../assets/img/responsible-shipping-background.webp); background-size: cover; background-repeat: no-repeat;">

  <div class="shippn-homepage-container container">
    <div class="row">
      <div style="text-align: center;" class="col-md-12">
        <h1
          style="text-align: center;font-size: 40px;font-weight: bold;margin-bottom: 170px;color: white;margin-top: 170px;">
          RESPONSIBLE SHIPPING</h1>
      </div>
    </div>
  </div>

</div>

<div style="background-color: #222222">
  <div class="shippn-homepage-container container">
    <div style="padding-top: 50px;padding-bottom: 50px;" class="row">
      <div style="text-align: left;" class="col-md-12">
        <h6 style="color: #fc7137;">Responsible Shipping</h6>
        <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 10px;">
        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          We want to create a community where everyone trust each other. Responsibility is what it takes to build such a
          community. New experiences, <br> earning money, helping people is great, but hosts must have a reasonable
          amount of commitment. Below here, you can find beneficial <br> information about being a reliable host.
        </p>

        <h6 style="color: #fc7137;">Safety</h6>
        <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 10px;">

        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          What can I do to make a package safe for shoppers?
        </p>

        <ul style="list-style: inside;">
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Secure the package or the product in a position that avoids the possibility of crushing, a fall, or a damage
            to the product.
          </li>
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Keep packages out of the reach of children, and protect the package to make sure it is not exposed to any
            kind of liquid or gas or direct sunshine.
          </li>
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Try to keep package around room temperature unless special conditions are required.
          </li>
        </ul>

        <h6 style="color: #fc7137;">Permissions</h6>
        <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 10px;">
        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          Whom should I notify that I’m hosting on Shippn?
        </p>

        <ul style="list-style: inside;">
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Roommates or flatmates,
          </li>
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Family Members,
          </li>
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Friends or,
          </li>
          <li style="color: #ffffff;font-size: 15px;font-weight: 300;">
            Anyone who can contact with the packages of your shopper
          </li>
        </ul>

        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          You may need to inform them about Shippn and what you are responsible for as a host.
        </p>

        <h6 style="color: #fc7137;">General Regulations</h6>
        <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 10px;">

        <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
          What local regulations apply to me? <br>
          Taxes:<br>
          <br>
          Ensure you look up any local taxes or business license requirements that may apply. This may include things
          like occupancy tax, sales, and other <br> turnover taxes such as Value Added Tax (VAT) or Goods and Services
          Tax (GST), or income tax. <br>
          <br>
          Permits or Registrations: <br>
          Ensure you look up any permitting, zoning, and safety regulations that may apply. The governing authorities
          may have useful information on such <br> regulations.
        </p>







      </div>
    </div>
  </div>
</div>